import styled, { css } from 'vue-styled-components';

import {
    square,
    COLORS,
    applyHoverAndPress,
    GRAY,
    BLUE,
} from '@/styles/common.styled';
import { FLEX_VERTICAL_CENTER_DIV } from '@/styles/common.styled.component';

import * as S from '../../styles';

export const MetricListWrapper = styled('div', { noList: Boolean })`
    border-radius: 2px;
    width: 100%;
    margin-bottom: 17px;
    overflow-y: auto;
    height: ${({ noList }) => (noList ? '100%' : 'auto')};
`;

export const DropdownWrapper = styled('div', { emptySearch: Boolean })`
    border: 1px solid ${COLORS['gray-20']};
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: ${COLORS['gray-10']};
    & > :first-child > div {
        border-top: unset;
    }

    .check-box {
        svg {
            top: 0;
        }
    }
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${COLORS['gray-25']};
    }
    ${({ emptySearch }) =>
        emptySearch &&
        css`
            height: 0;
            border-bottom: none;
            overflow: hidden;
        `}
`;

export const ComponentWrapper = styled.div``;

export const ItemListWrpper = styled.div`
    & .category-edit {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity 0.15s ease;
    }

    &.item-list-wrapper:hover .category-edit,
    &.item-list-wrapper:focus-within .category-edit {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }

    .item-box-elem {
        width: 100%;
        height: auto;
        padding: 7px 7px 7px 15px;
        background: #fff;
        min-height: 33px;
        cursor: pinter;
        color: ${GRAY(100)};
        display: flex;
        align-items: center;

        & .item-main-area {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 0;
        }

        & .item-text {
            display: flex;
            align-items: center;
            font-size: 14px;
            width: 100%;
            text-align: left;
            margin-right: 8px;
            word-break: break-word;
            color: ${GRAY(100)};

            &.selected {
                color: ${BLUE(60)};

                & svg {
                    width: 16px;

                    path {
                        fill: ${BLUE(60)};
                    }
                    &.check-icon {
                        margin-right: 8px;
                    }
                }
            }

            & > span.item-text-span {
                max-width: 100%;
                width: 100%;
                /* display: flex;
            align-items: center; */

                & .tooltip-item {
                    position: absolute;
                    border: 1px solid gray;
                    padding: 10px;
                    border-radius: 5px;
                    display: none;
                    background: #fff;
                    z-index: 99999999;
                    right: 80px;
                    white-space: pre-line;
                    max-width: 400px;
                }
                &.active:hover {
                    & .tooltip-item {
                        display: block;
                    }
                }

                .connector-count {
                    margin-left: 8px;
                    font-size: 12px;
                    color: ${GRAY(60)};
                    font-weight: 500;
                }
            }
        }

        .checkbox-wrapper {
            & > div {
                cursor: pointer;
            }

            .check {
                background-color: ${({ disabled }) =>
                    disabled ? GRAY(40) : BLUE(60)};
            }
        }

        .icons-area {
            & svg {
                cursor: pointer;
                ${applyHoverAndPress(GRAY(30), 'fill')};
                ${square(16)};
                display: none;
                &.edit-icon {
                    margin-right: 6px;
                }
                &.trash-icon {
                    margin-right: 8px;
                }

                &.bookmark-icon.on {
                    display: flex;
                }
            }
            margin-left: auto;
            /* display: none; */
            display: flex;
            align-items: center;

            & *:not(:first-child) {
                margin-left: 4px;
            }
        }

        &:hover {
            background-color: rgba(0, 0, 0, 0.03);
            & svg {
                display: block;
            }
            & .trash-icon,
            & .edit-icon {
                display: block;
            }
        }

        &.disabled {
            cursor: not-allowed;

            & .item-text {
                color: ${GRAY(40)};
            }

            .checkbox-wrapper {
                & > div {
                    cursor: not-allowed;
                    background-color: ${GRAY(40)};
                }

                .check {
                    background-color: ${({ disabled }) =>
                        disabled ? GRAY(40) : BLUE(60)};
                }
            }
        }
    }

    .item-box-elem__checkbox-wrapper {
        display: flex;
        align-items: center;
        margin-right: 8px;

        & :first-child.checkbox-wrapper {
            margin-right: 2px;
        }
    }

    /* .item-box-dummy {
        width: 100%;
        height: auto;
        padding: 7px 7px 7px 15px;
        background: #fff;
        min-height: 33px;
        cursor: pointer;
        color: #080a0d;
    } */
`;

export const TitleLabel = styled(S.TitleLabel, {
    hasBtn: Boolean,
    isClosed: Boolean,
})`
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 15px;
    border-top: 1px solid ${COLORS['gray-20']};
    ${({ hasBtn }) =>
        hasBtn &&
        css`
            padding: 3px 15px;
        `}

    & .accordion {
        ${square(16)};
        margin-right: 8px;
        transform: ${({ isClosed }) => (isClosed ? 'unset' : 'rotate(180deg)')};
        margin-right: unset;
    }

    & .item-list-actions {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    & .category-edit {
        ${square(16)};
        cursor: pointer;
    }
`;

export const EmptyCategoryRow = styled.div`
    padding: 8px 15px;
    color: ${GRAY(60)};
    font-size: 12px;
`;

export const ItemWrapper = styled(S.ItemWrapper, { isClosed: Boolean })`
    background: #fff;
    padding: 4px 0;
    ${({ isClosed }) =>
        isClosed &&
        css`
            height: 0;
            overflow: hidden;
            padding: 0;
        `}
`;

export const ItemCheckWrapper = styled.div`
    margin-right: 8px;
`;

export const ItemTextWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex: 1;
    align-items: start;

    & > svg {
        ${square(16)};
        margin-right: 8px;
    }
    & > img {
        ${square(16)};
        margin-right: 8px;
    }
`;

export const ItemBox = styled(FLEX_VERTICAL_CENTER_DIV, { disabled: Boolean })`
    width: 100%;
    height: auto;
    padding: 7px 7px 7px 15px;
    background: #fff;
    min-height: 33px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    color: ${GRAY(100)};
    & .item-text {
        display: flex;
        align-items: center;
        font-size: 14px;
        width: 100%;
        text-align: left;
        margin-right: 8px;
        word-break: break-word;
        color: ${({ disabled }) => (disabled ? GRAY(40) : GRAY(100))};

        &.selected {
            color: ${BLUE(60)};

            & svg {
                width: 16px;

                path {
                    fill: ${BLUE(60)};
                }
                &.check-icon {
                    margin-right: 8px;
                }
            }
        }

        & > span.item-text-span {
            max-width: 100%;
            width: 100%;
            /* display: flex;
            align-items: center; */

            & .tooltip-item {
                position: absolute;
                border: 1px solid gray;
                padding: 10px;
                border-radius: 5px;
                display: none;
                background: #fff;
                z-index: 99999999;
                right: 80px;
                white-space: pre-line;
                max-width: 400px;
            }
            &.active:hover {
                & .tooltip-item {
                    display: block;
                }
            }
        }
    }

    .checkbox-wrapper {
        & > div {
            cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
            ${({ disabled }) => disabled && `background-color: ${GRAY(40)}`}
        }

        .check {
            background-color: ${({ disabled }) =>
                disabled ? GRAY(40) : BLUE(60)};
        }
    }

    .icons-area {
        & svg {
            cursor: pointer;
            ${applyHoverAndPress(GRAY(30), 'fill')};
            ${square(16)};
            display: none;
            &.edit-icon {
                margin-right: 6px;
            }
            &.trash-icon {
                margin-right: 8px;
            }

            &.bookmark-icon.on {
                display: flex;
            }
        }
        margin-left: auto;
        /* display: none; */
        display: flex;
        align-items: center;

        & *:not(:first-child) {
            margin-left: 4px;
        }
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.03);
        & svg {
            display: block;
        }
        & .trash-icon,
        & .edit-icon {
            display: block;
        }
    }
`;

export const CheckBoxWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-right: 8px;
    & :first-child.checkbox-wrapper {
        margin-right: 2px;
    }
`;

export const Logo = styled.img`
    ${square(16)};
    margin-right: 8px;
`;
